import { Component, Prop, Element, h, Host } from '@stencil/core';

/**
 * @slot default - Text for the tab
 * @slot icon - renders an icon for the tab
 */
@Component({
  tag: 'uui-tab',
  styleUrl: 'uui-tab.css',
  shadow: true
})
export class UUITab {
  /** selected Tab */
  @Prop({ reflect: true, mutable: true }) active: boolean;
  /** index of the tab */
  @Prop({ reflect: true }) tabItemIndex: number | string;
  /** disable tab */
  @Prop({ reflect: true, mutable: true }) disabled: boolean;
  /** type of tab to render - note this field is often not required. Please set type of parent element to ensure all tabs render as same type*/
  @Prop({reflect: true}) type: 'icon' | 'text' = 'text';
  @Element() el: HTMLElement;

  render() {
    const type =  this.el.parentElement?.getAttribute('type') ?? '';
    return (
      <Host>
        {type === 'icon' || this.type === 'icon' ? (
          <uui-button variant="icon" active={this.active}>
            <slot />
          </uui-button>
        ) : (
          <button disabled={this.disabled}>
            <slot name="icon" />
            <slot />
          </button>
        )}
      </Host>
    );
  }
}
